﻿export class UserModel {
    data: Array<UserRoleListModel> = new Array<UserRoleListModel>();
}

export class UserRoleListModel {
    userSurrKey: number = 0;
    userEmail: string = "";
    userFullName: string = "";
    userName: string = "";
    userSurname: string = "";
    compannySurrKey: number = 0;
    userPhone: string = "";
    isLoginBo: number = 0;
    check: boolean = false;
}

export class EditPermissionUserModel {
    userSurrKey: number = 0;
    userEmail: string = "";
    check: boolean = false;
}

